import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { MarketButton } from '@market/react';
import Gear from '@square-icons/react/24/Misc/gear';
import File from '@square-icons/react/16/UI/file';

const ShippingLabels = ({ checkoutClient }) => {
  const { t } = useTranslation();

  const [err, setErr] = useState(null);
  const [labels, setLabels] = useState([]);
  const [loading, setLoading] = useState(false);

  const onClick = () => {
    setLoading(true);
    checkoutClient.fetchLabels().then(
      (data) =>
        data?.labels.length > 0
          ? setLabels(data.labels)
          : setErr(t('checkout.complete.labelsError')),
      () => setErr(t('checkout.complete.labelsError')),
    );
  };

  // Either a button to generate labels or a list of buttons that link to labels
  const cta =
    labels.length === 0 ? (
      <MarketButton
        {...(loading ? { isLoading: true } : {})}
        rank="primary"
        onClick={onClick}
        style={{ margin: '8px 0px', width: '100%' }}
      >
        <Gear slot="icon" />
        {t('checkout.complete.generateLabels')}
      </MarketButton>
    ) : (
      labels.map((label, idx) => (
        <MarketButton
          key={`label-${idx}`}
          href={label}
          target="_blank"
          style={{ margin: '8px 0px', width: '100%' }}
        >
          <File slot="icon" />
          {t('checkout.complete.openLabel', { num: idx + 1 })}
        </MarketButton>
      ))
    );

  return (
    <>
      <Box component="h3" sx={{ mb: 1 }}>
        {t('checkout.complete.printLabels')}
      </Box>
      <p>{t('checkout.complete.labelsNotice')}</p>
      {err ? (
        <p
          className="semibold-30"
          style={{ margin: '8px 0px', textAlign: 'center' }}
        >
          {err}
        </p>
      ) : (
        cta
      )}
    </>
  );
};

export default ShippingLabels;
